import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IRejectMeetingRequestByIDPayload extends ISagaCb {
    requestId: string
    data: {
        reason: string
    }
}

export interface IRejectMeetingRequestByIDState {
    status: string
    data: any
    errors: any
}

const initialState: IRejectMeetingRequestByIDState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const rejectMeetingRequestByID = createSlice({
    name: 'meeting-requests/reject-by-id',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IRejectMeetingRequestByIDPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const rejectMeetingRequestByIDActions = rejectMeetingRequestByID.actions
export default rejectMeetingRequestByID.reducer
